@use '../../../sass/theme';
@use '../../../sass/form-control-mixins';

:host {
  display: block;
}

.jui-image-capture {
  display: flex;
  flex-direction: column;
  row-gap: var(--jds-space-sm);

  &__label {
    @include form-control-mixins.form-control-label;
  }

  &__list {
    display: flex;
    flex-direction: column;
    row-gap: var(--jds-space-lg);
    margin: 0;
    padding: 0;
    list-style: none;
    container-type: inline-size;
  }

  &__item {
    display: flex;
    flex-direction: column;

    &--with-verdict {
      flex-direction: row;
      align-items: flex-start;
      column-gap: var(--jds-space-lg);
      padding: var(--jds-space-inset-sm);
      border: 1px solid var(--jds-theme-color-border-contrast-10);
      border-radius: var(--jds-theme-ui-border-radius);
      box-shadow: var(--jds-theme-ui-shadow);
    }
  }

  &__item--with-verdict &__photo {
    flex: 1;
    order: -1;
    min-width: 0;
    margin-top: 0;
  }

  &__item--with-verdict > ::slotted(*) {
    flex: 0 0 320px;
    max-width: 320px;
  }

  @container (width < 450px) {
    &__item--with-verdict {
      flex-direction: column;
      row-gap: var(--jds-space-sm);
    }

    &__item--with-verdict > ::slotted(*) {
      flex-basis: auto;
      width: 100%;
      max-width: none;
    }
  }

  &__photo {
    display: flex;
    flex-direction: column;
    align-self: center;
    max-width: 100%;
    margin-top: var(--jds-space-xs);

    &--placeholder {
      align-self: stretch;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    column-gap: var(--jds-space-xs);
    padding: var(--jds-space-inset-squish-xs);
    background: var(--jds-theme-color-state-low-emphasis, #e2e2e2);
    border-top-left-radius: var(--jds-theme-ui-border-radius);
    border-top-right-radius: var(--jds-theme-ui-border-radius);
  }

  &__extra-actions {
    flex: 1;
  }

  &__frame {
    position: relative;
    overflow: hidden;
    border: 2px solid var(--jds-theme-color-border);
    border-radius: var(--jds-theme-ui-border-radius);

    &[role='button'] {
      cursor: pointer;
    }
  }

  &__photo--with-actions &__frame {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  &__media {
    display: block;
    box-sizing: border-box;
    max-width: 100%;
    max-height: 450px;

    &--error {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 150px;
      background-color: var(--jds-theme-color-bg-surface-contrast-10);
    }
  }

  &__overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
  }
}
